import { ApiService } from "./api.service";
export default class NotepadVersionService extends ApiService {
  namespace = "type";
  icon = "BlueCube";
  name = "Notepad Version";
  favicon = "Bullets";
  window = 290;
  Width = 690;
  DOMAIN = -51;
  serachListing = true;
  columns = [
    {
      header: this.t("Version"),
      icon: "Number",
      field: "display_name",
    },
    {
      header: this.t("Modifier"),
      icon: "UserSilhouette",
      field: "number",
    },
    {
      header: this.t("Last Modified"),
      icon: "Hourglass",
      field: "number",
    },
    {
      header: this.t("Date"),
      icon: "Calendar",
      field: "number",
    },
  ];

  constructor() {
    super("notepad-version");
  }
}
